import React, { useState } from 'react'
import { Modal, Button, Spin } from 'antd'
import { forceRetryBatch } from '../../../../../services/api/3dApi'
import Promise from "bluebird"
import classNames from 'classnames'

export const ActionForceRetry = ({ isOpen, closeModal, selectedItems, refreshBatches, toggleSelectAll, batches }) => {
    const [loading, setLoading] = useState(false)
    const [isChange, setIsChange] = useState(false)
    const [itemsSuccess, setItemsSuccess] = useState([])
    const [itemError, setItemError] = useState([])

    const listBatches = batches.filter(batch => selectedItems.includes(batch._id))
    const listBatchSelected = batches.filter(batch => selectedItems.includes(batch._id)) || []

    const onChangeStatus = async () => {
        setLoading(true)
        setIsChange(true)

        await Promise.each(listBatchSelected, async item => {
            try {
                const { tags = [], _id } = Object.assign({}, item)
                if(tags.includes("force_rgb")) {
                    itemError.push({
                        _id: _id,
                        message: "Không thao tác nhiều với lô Force RGB."
                    })
                    setItemError([...itemError])
                    return
                }

                const { data: response } = await forceRetryBatch(_id)
                const { success, error } = response

                if (!success) {
                    setLoading(false)
                    itemError.push({
                        _id: _id,
                        message: error
                    })
                    setItemError([...itemError])
                } else {
                    itemsSuccess.push(_id)
                    setItemsSuccess([...itemsSuccess])
                }

            } catch (e) {
                setLoading(false)
                throw Error(e.message)

            } finally {
                setLoading(false)
            }
        })
    }

    const _showMessage = (itemError, itemsSuccess, _id) => {
        if (itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if (itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">
                        {itemError.find(itemErr => _id === itemErr._id).message}
                    </span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if (itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Retry thành công!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    const _hanldeClose = () => {
        closeModal()
        toggleSelectAll(false)
        refreshBatches()
    }

    return (
        <Modal
            title="Force retry"
            visible={isOpen}
            onOk={onChangeStatus}
            onCancel={closeModal}
            className="custom-modal-confirm-batch"
            footer={[
                <Button key="back" onClick={closeModal} className={!isChange ? "" : "d-none"}>
                    Hủy
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={onChangeStatus}
                    className={!isChange ? "" : "d-none"}
                >
                    Force retry
                </Button>,
                <Button onClick={_hanldeClose} className={`bg-grey ml-2 ${isChange ? "" : "d-none"}`}>
                    Close
                </Button>
            ]}
        >
            {!isChange ?
                <div>
                    <h6>Xác nhận download / gộp file in của {selectedItems.length} lô:</h6>
                    <ul>
                        {listBatchSelected.map((batch) => {
                            const { status } = Object.assign({}, batch)
                            const color = classNames({
                                'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
                                'printing progress-bar-animated progress-bar-striped': status === 'printing',
                                'printed': status === 'printed',
                                'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
                                'transferred': status === 'transferred',
                                'confirmed': status === 'confirmed',
                                'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
                                'sewing': status === 'sewing',
                                'completed': status === 'completed' || status === 'done',
                            })
                            return (
                                <li key={batch._id}>{`${batch.basename}`} <span className={`badge ${color} badge-pill`}>{status}</span></li>
                            )
                        })}
                    </ul>
                </div>
                : (
                    <div className="ListChangeStatusBatch">
                        {listBatches.length > 0 && (
                            listBatches.map(item => {
                                return (
                                    <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                                        <div className="IconStatus mr-2 d-flex align-items-end">
                                            {itemsSuccess.includes(item._id) && (
                                                <Button icon="check" className='icon-check text-success'></Button>
                                            )}
                                            {
                                                (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) && (
                                                    <Button icon="cross" className='icon-cross text-danger'></Button>
                                                )
                                            }
                                        </div>
                                        <div className="ContentGenLabel">
                                            <strong className='mr-2'>{item.name}</strong>
                                            {loading && <Spin />}
                                            {_showMessage(itemError, itemsSuccess, item._id)}
                                        </div>
                                    </div>
                                )
                            })
                        )}
                    </div>
                )
            }
        </Modal>
    )
}
